<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="part04"><a id="page_51"></a>IV<br/>FROM CHEROKEE TO COMANCHE</h2>
<p class="noindentm"><em>Commissioner: ‘Where are the prisoners you promised to bring into this Council?</em>’</p>
<p class="indentm"><em>Comanche Chief: ‘We have brought in the only one we had; the others are with other tribes. How … do you like the answer?</em>’</p>
<p class="noindentm">‘<em>The Indians … approached … the town … riding very nearly at full speed, and in the shape of a half-moon.… The citizens … had to flee to the bay where most of them were saved by getting into a lighter.</em>’</p>
<p class="att">W<span class="small">ILLIAM</span> H. W<span class="small">ATTS</span></p>
<p class="noindentm">‘<em>Many of the arms, and most of the saddles and baggage were left. We ate, drank and rested for a moment; I then had a bon-fire made of most of the Indian trumpery.</em>’</p>
<p class="att"><em>Captain J</em>. R. C<span class="small">UNNINGHAM</span><a id="page_52"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part04.vue?7fafd08b